import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Hairline, Icon, Swatch, type SwatchKind } from "@/components/primitives";
import { MobileFrame } from "@/components/MobileFrame";

export default function Archive() {
  const nav = useNavigate();
  const [tab, setTab] = useState("Labels");
  const labels: { tag: string; years: string; count: number; k: SwatchKind }[] = [
    { tag: "ILGWU", years: "1974–1995", count: 4820, k: "stripes" },
    { tag: "UNITE HERE", years: "1995–present", count: 2140, k: "rust" },
    { tag: "Sanforized", years: "1930s–70s", count: 1290, k: "olive" },
    { tag: "Union Made", years: "pre-1974", count: 980, k: "cream" },
    { tag: "Made in USA", years: "all", count: 12480, k: "ink" },
    { tag: "WPL number", years: "1941–1959", count: 410, k: "stripes" },
  ];
  const tabs = ["Labels", "Hardware", "Seams", "Care"];
  return (
    <MobileFrame>
      <div className="paper-bg" style={{ minHeight: "100vh", paddingBottom: 40 }}>
        <div style={{ padding: "12px 20px 0", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <button onClick={() => nav(-1)} style={{ background: "none", border: "none", padding: 6, cursor: "pointer", color: "hsl(var(--ink))" }}>{Icon.chev(18, "l")}</button>
          <span className="caps">Vol. 03 · Apr 2026</span>
          <div style={{ width: 30 }} />
        </div>

        <div style={{ padding: "12px 20px 0" }}>
          <span className="caps" style={{ color: "hsl(var(--rust))" }}>The Encyclopedia</span>
          <div style={{ fontFamily: "'Fraunces', 'Playfair Display', serif", fontWeight: 900, fontSize: 56, color: "hsl(var(--ink))", letterSpacing: "-0.03em", lineHeight: 0.9, marginTop: 4 }}>
            The Archive
          </div>
          <div style={{ fontFamily: "'Fraunces', 'Playfair Display', serif", fontSize: 15, color: "hsl(var(--ink-2))", marginTop: 6 }}>
            <span style={{ color: "hsl(var(--rust))", fontWeight: 700 }}>14,382,904</span> garments catalogued by the community.
          </div>
        </div>

        <div style={{ padding: "16px 20px 0" }}>
          <div style={{ border: "1px solid hsl(var(--ink))", background: "hsl(var(--cream))", padding: "10px 12px", display: "flex", gap: 8, alignItems: "center" }}>
            {Icon.search(16)}
            <span style={{ fontFamily: "'Fraunces', 'Playfair Display', serif", fontSize: 14, color: "hsl(var(--ink-2))" }}>
              Search 2.4M labels, hardware, care tags…
            </span>
          </div>
        </div>

        <div style={{ padding: "16px 20px 0", display: "flex", gap: 6 }}>
          {tabs.map((t) => (
            <button key={t} onClick={() => setTab(t)} style={{
              padding: "6px 10px", border: "1px solid hsl(var(--ink))", cursor: "pointer",
              background: tab === t ? "hsl(var(--ink))" : "transparent",
              color: tab === t ? "hsl(var(--cream))" : "hsl(var(--ink))",
              fontFamily: "'IBM Plex Mono', monospace", fontSize: 10, letterSpacing: "0.1em",
              textTransform: "uppercase",
            }}>{t}</button>
          ))}
        </div>

        <div style={{ padding: "14px 20px 0", display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
          {labels.map((l, i) => (
            <div key={i} style={{ background: "hsl(var(--cream))", border: "1px solid hsl(var(--ink))" }}>
              <Swatch kind={l.k} style={{ width: "100%", aspectRatio: "1.4/1", borderBottom: "1px solid hsl(var(--ink))", position: "relative" }}>
                <div style={{
                  position: "absolute", inset: "18% 12%", background: "hsl(var(--paper))",
                  border: "1px solid hsl(var(--ink))", display: "flex",
                  alignItems: "center", justifyContent: "center",
                  fontFamily: "'Fraunces', 'Playfair Display', serif", fontWeight: 800, fontSize: 13,
                  color: "hsl(var(--ink))", letterSpacing: "-0.01em",
                }}>{l.tag}</div>
              </Swatch>
              <div style={{ padding: "8px 10px 10px" }}>
                <div style={{ fontFamily: "'Fraunces', 'Playfair Display', serif", fontWeight: 700, fontSize: 14, color: "hsl(var(--ink))", lineHeight: 1.1 }}>
                  {l.tag}
                </div>
                <div className="caps" style={{ marginTop: 3 }}>{l.years}</div>
                <div style={{ fontFamily: "'IBM Plex Mono', monospace", fontSize: 10, color: "hsl(var(--rust))", marginTop: 4 }}>
                  {l.count.toLocaleString()} scanned
                </div>
              </div>
            </div>
          ))}
        </div>

        <div style={{ padding: "18px 20px 0" }}>
          <Hairline dashed />
          <div style={{ fontFamily: "'Fraunces', 'Playfair Display', serif", fontSize: 13, color: "hsl(var(--ink-2))", marginTop: 10, lineHeight: 1.4 }}>
            Every scan you perform feeds The Archive. Your contributions make the next person's verification faster and more accurate. <span style={{ color: "hsl(var(--rust))", fontWeight: 700 }}>You've contributed 41.</span>
          </div>
        </div>
      </div>
    </MobileFrame>
  );
}
